document.addEventListener("DOMContentLoaded", () => {
  const loadedScripts = new Set();
  const loadedStyles = new Set();
  document.querySelectorAll('script[src]').forEach(script => {
      if (loadedScripts.has(script.getAttribute('src'))) {
          script.parentNode.removeChild(script);
      } else {
          loadedScripts.add(script.getAttribute('src'));
      }
  });
  document.querySelectorAll('link[rel="stylesheet"]').forEach(link => {
      if (loadedStyles.has(link.getAttribute('href'))) {
          link.parentNode.removeChild(link);
      } else {
          loadedStyles.add(link.getAttribute('href'));
      }
  });
});
